import axios from '@/plugins/axios';

export default {
  namespaced: true,

  actions: {

    // 認証情報取得
    async getAuthenticationUser() {
      // 初期化
      let result: any;

      // URL:GET /api/authentication/user
      // params: なし
      await axios.get(`/api/authentication/user`)
        .then((response) => {
          // 通信結果正常時
          //   レスポンス（HTTPステータスコード、認証ユーザー情報）を通信結果に設定
          result = response;
        })
        .catch((error) => {
          // 通信結果エラー時
          //   レスポンス（HTTPステータスコード、エラーメッセージ）を通信結果に設定
          result = error.response;
        });

      // 通信結果を返す
      return result;
    }

  }

}
